import React, { useCallback, useContext } from 'react';
import { GridDate as GridDateBase } from 'components/Grid';
import LedgerContext from 'context/LedgerContext';
import { LedgerGridDateProps } from './LedgerGridDate.props';

const LedgerGridDate = ({ cell, minDate = undefined }: LedgerGridDateProps) => {
  const { onCellsChange } = useContext(LedgerContext);

  const handleOnChange = useCallback(
    (date: string) => {
      onCellsChange([{ cell, value: date }]);
    },
    [cell, onCellsChange]
  );

  const { value, readOnly, disabled } = cell;

  return (
    <GridDateBase
      cell={cell}
      value={value as string}
      readOnly={readOnly}
      disabled={disabled}
      onCellsChanged={handleOnChange}
      minDate={minDate}
    />
  );
};

export default LedgerGridDate;
